import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class AppInsightsService {
  appInsights: ApplicationInsights;
  public appName = 'SDWeb';
  //  Trace = 0, Debug = 1, Information = 2, Warning = 3, Error = 4, Critical = 5

  constructor() {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: environment.appInsights.instrumentationKey
      }
    });
    this.appInsights.loadAppInsights();
  }

  logError(error: any, severityLevel?: number) {
    let message = '';
    let stack = '';
    let status = error?.status ?? '';

    // Try to extract the message and stack from different error shapes
    if (error instanceof Error) {
      message = error.message || error.toString();
      stack = error.stack || '';
    } else if (typeof error === 'string') {
      message = error;
    } else if (error && typeof error === 'object') {
      // Try to handle Angular zone errors and promise rejections
      if (error.rejection) {
        message = error.rejection.message || JSON.stringify(error.rejection);
        stack = error.rejection.stack || '';
        status = error.rejection.status ?? status;
      } else {
        message = error.message || JSON.stringify(error);
        stack = error.stack || '';
      }
    } else {
      message = String(error);
    }
    let messageToLog = `${this.appName}: [Error]: ${message} [Status]: ${status} [Stack trace]: ${stack}`;

    // Log to traces with error message and stack trace as properties
    this.appInsights.trackTrace({
      message: messageToLog,
      severityLevel: severityLevel ?? 4,
      properties: {
        stack: stack,
        status: status,
        error: message
      }
    });
  }

  logException(exception: Error, severityLevel?: number) {
    this.appInsights.trackException({ exception, severityLevel });
  }
  logEvent(name: string, properties?: { [key: string]: any }) {
    this.appInsights.trackEvent({ name }, properties);
  }
}
